import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { UINotification } from '../models/ui-notification.model';

@Injectable({
  providedIn: 'root'
})
export class UINotificationService {
  private _message = new Subject<UINotification>();

  public message$ = this._message.asObservable();

  add(messeage: UINotification) {
    this._message.next(messeage);
  }
}
